module.exports = __webpack_public_path__ + "static/media/recipe_banner_ja.ee3c57d5.png";